import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-aiAnalysis",
  "use": "icon-aiAnalysis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-aiAnalysis\"><path d=\"M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 64a448 448 0 1 0 0 896A448 448 0 0 0 512 64zM423.68 320.064L601.344 704H536.512L413.824 455.488 298.24 704.384H224L409.28 320h14.528zM736 320v384h-64V320h64z\" p-id=\"1365\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol